import makeCrud from '@/store/site/localization/crud'

const module = makeCrud('manager_lead')

module.actions.board = async function () {
    const res = await this._vm.axios.get(this._vm.endpoint.get('manager_lead_board'))
    return res.data
}
module.actions.updateStage = async function (_, { id, stage, board_sort }) {
    const res = await this._vm.axios.put(this._vm.endpoint.get('manager_lead') + '/' + id + '/stage', { stage, board_sort })
    return res.data
}
module.actions.convert = async function (_, { id }) {
    const res = await this._vm.axios.post(this._vm.endpoint.get('manager_lead') + '/' + id + '/convert')
    return res.data
}

export default module
